<template>
  <svg
    width="28"
    height="28"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28.86 28.53"
    fill="none"
  >
    <path
      stroke="currentColor"
      :stroke-width="bigger ? '1.5' : '2.2'"
      d="M12,2.29a2.72,2.72,0,0,1,4.9,0A2.72,2.72,0,0,0,20.46,3.6a2.72,2.72,0,0,1,3.76,3.15,2.73,2.73,0,0,0,1.9,3.3A2.72,2.72,0,0,1,27,14.88a2.73,2.73,0,0,0-.66,3.75,2.71,2.71,0,0,1-2.45,4.24,2.73,2.73,0,0,0-2.92,2.45A2.72,2.72,0,0,1,16.33,27a2.7,2.7,0,0,0-3.8,0,2.72,2.72,0,0,1-4.61-1.68A2.73,2.73,0,0,0,5,22.87a2.71,2.71,0,0,1-2.45-4.24,2.73,2.73,0,0,0-.66-3.75,2.72,2.72,0,0,1,.85-4.83,2.73,2.73,0,0,0,1.9-3.3A2.72,2.72,0,0,1,8.4,3.6,2.72,2.72,0,0,0,12,2.29Z"
    />
    <circle
      stroke="currentColor"
      :stroke-width="bigger ? '1.5' : '2.2'"
      cx="14.43"
      cy="14.6"
      r="4.88"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSetting',
  props: {
    bigger: {
      type: Boolean,
      default: false
    }
  }
}
</script>
